import type { DemandStatus, TaskExecutionStatus, PlanStatus, PlanType } from '../../types/engineering';

type McTagAppearance = 'neutral' | 'success' | 'warning' | 'error' | 'info';

export function demandStatusAppearance(status: DemandStatus): McTagAppearance {
  switch (status) {
    case 'DONE':
      return 'success';
    case 'INPROGRESS':
      return 'info';
    case 'PLANNING_ERROR':
      return 'error';
    case 'WAITING_REVIEW':
    case 'TESTING':
    case 'PLANNING':
      return 'warning';
    case 'BACKLOG':
    case 'CANCELLED':
    default:
      return 'neutral';
  }
}

export function taskExecutionStatusAppearance(status: TaskExecutionStatus): McTagAppearance {
  switch (status) {
    case 'DONE':
      return 'success';
    case 'IMPLEMENTING':
      return 'info';
    case 'PLANNING_ERROR':
    case 'IMPLEMENTING_ERROR':
    case 'SCANNING_VULNERABILITIES_ERROR':
    case 'TEST_ERROR':
    case 'ERROR':
    case 'REJECTED':
      return 'error';
    case 'WAITING_REVIEW':
    case 'SCANNING_VULNERABILITIES':
      return 'warning';
    case 'PLANNING':
    default:
      return 'neutral';
  }
}

export function planStatusAppearance(status: PlanStatus): McTagAppearance {
  switch (status) {
    case 'WAITING_IMPLEMENTATION':
      return 'info';
    case 'DONE':
      return 'success';
    case 'REJECTED':
      return 'error';
    case 'FAILED':
      return 'error';
    case 'WAITING_REVIEW':
    default:
      return 'warning';
  }
}

export function formatDemandStatus(status: DemandStatus): string {
  return status.replace(/_/g, ' ');
}

export function formatTaskExecutionStatus(status: TaskExecutionStatus): string {
  return status.replace(/_/g, ' ');
}

export function formatPlanType(type: PlanType): string {
  return type.charAt(0) + type.slice(1).toLowerCase();
}

export function formatCost(cost?: number): string {
  if (cost == null) return '—';
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(cost);
}
